<template>
  <div class="sendmsg_popup" v-loading="loading" :element-loading-text="loadingText">
    <el-input class="msg_content" v-model="message" type="textarea" placeholder="请输入要发送的内容" :autosize="{ minRows: 12,maxRows: 12}"></el-input>
    <el-button class="search_btn" @click="sendMsg">发 送</el-button>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";

export default {
  components: {},
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    Phone: String,
  },
  data() {
    return {
      loading:false,
      loadingText:"发送中...",
      message: "",
    };
  },
  methods: {
    sendMsg() {
      if (this.message == null || this.message == "") {
        this.$message({
          type: "error",
          message: "请输入短信内容",
        });
        return;
      }


      if (this.Phone != null) {
        this.loading = true;
        new MyApis.SendSmsApi()
          .SendSms({
            // Id: 1,
            Id: ZJApp.ZJUtils.uuid(),
            PhoneNo: this.Phone,
            Content: this.message, 
            Charset: "GBK",
            Creater: ZJApp.ZJUser.current.UserName,
            CreateTime: new Date(),
            Modifier: ZJApp.ZJUser.current.UserName,
            ModifyTime: new Date(),
            SendTime: new Date(),
            Extends2: this.Phone,
          })
          .then((r) => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "消息发送成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "消息发送失败!",
              });
            }
            this.loading = false;
          })
          .catch((e) => {
            console.error(e);
            this.$message(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      } else {
        this.$message({
          type: "error",
          message: "电话号码不能为空",
        });
        return;
      }
    },
  },
};
</script>

<style scoped>
</style>